export const SYSTEM_ACCOUNT_TYPE = "מערכת" as const;
export const SYSTEMS_PATH = "/systems";
export const SYSTEMS_BREADCRUMB = { ledger: "כרטסות", list: "מערכות" } as const;
export const SYSTEMS_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
